import { svg } from 'lit';
export const arrowTopToRightRounded32 = svg `
<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.75 1C16.75 0.585786 16.4142 0.25 16 0.25C15.5858 0.25 15.25 0.585786 15.25 1L16.75 1ZM32 17L24.5 12.6699L24.5 21.3301L32 17ZM15.25 1L15.25 9L16.75 9L16.75 1L15.25 1ZM25.25 16.25L24 16.25L24 17.75L25.25 17.75L25.25 16.25ZM15.25 9C15.25 13.8325 19.1675 17.75 24 17.75L24 16.25C19.9959 16.25 16.75 13.0041 16.75 9L15.25 9Z" fill="url(#paint0_linear_16084_20368)"/>
<defs>
<linearGradient id="paint0_linear_16084_20368" x1="24" y1="1" x2="24" y2="17" gradientUnits="userSpaceOnUse">
<stop stop-color="#F2F4F7"/>
<stop offset="1" stop-color="#D0D5DD"/>
</linearGradient>
</defs>
</svg>
`;
//# sourceMappingURL=arrow-top-to-right-rounded_32.js.map